import Inb from "@/modules/inb/service/Inb";
import Core from "@/modules/core/service/Core";

const state = {
    top          : [],
    topCount     : 0,
    toptimestamp : null,
    messageTypes : [],
    invoiceTypes : [],
    incidentTypes: [],
    assessmentTypes: [],
    assessmentResults: [],
    customerQualityCounts: [],
}

const mutations = {
    updateInboxEnums (state, payload) {
        state.messageTypes  = payload.messageTypes;
        state.invoiceTypes  = payload.invoiceTypes;
        state.incidentTypes = payload.incidentTypes;
        state.assessmentTypes = payload.assessmentTypes;
        state.assessmentResults = payload.assessmentResults;
    },

    updateMessages (state, payload) {
        state.top          = payload.messages;
        state.toptimestamp = payload.timestamp
    },

    updateCount (state, payload) {
        state.topCount  = payload;
    },

    updateCustomerQualityCounts (state, payload) {
        state.customerQualityCounts = payload;
    }
}

const actions = {
    initInboxEnums ( { commit }) {
        return Core.method.get(Inb.url.enums).then(data => {
            commit ('updateInboxEnums', data);
        })
    },

    getMessagesByUser ( { commit }, { customers, force }) {
        return Core.method.post(Inb.url.data, {
            customers: customers,
            force    : !!force,
            timestamp: state.toptimestamp
        }).then(data => {
          //  if (!data.valid) {
          //      return;
          //  }

            commit ('updateMessages', data);
        });
    },

    getMessageCountByUser ( { commit }, { customers, force }) {
        console.log("getMessageCountByUser")
        return Core.method.post(Inb.url.messageCount, {
            customers: customers,
            force    : !!force,
            timestamp: state.toptimestamp
        }).then(data => {
            commit ('updateCount', data);
        });
    },

    loadCustomerQualityCounts ({ commit }) {
        Inb.message.counts(data => {
            commit ('updateCustomerQualityCounts', data);
        });
    },
}

const getters = {
    messageTypes: state => {
        return state.messageTypes;
    },

    invoiceTypes: state => {
        return state.invoiceTypes;
    },

    inboxIncidentTypes: state => {
        return state.incidentTypes;
    },

    messages: state => {
        return state.top;
    },

    messageCount: state => {
        return state.topCount;
    },


    customerQualityCounts: state => {
        return state.customerQualityCounts;
    },

    inb: state => {
        return state;
    },
}

const imbModule = {
    state,
    mutations,
    actions,
    getters
}

export default imbModule